/* eslint-disable */
import {
  createStyles,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Theme,
  withStyles,
  Button,
} from "@material-ui/core";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import SubdirectoryArrowRightIcon from "@material-ui/icons/SubdirectoryArrowRight";
import DeleteIcon from "@material-ui/icons/Delete";
import { connect } from "react-redux";
import { show } from "redux-modal";
// reactstrap components
import { Row } from "reactstrap";
import {
  getClients,
  getAllFunds,
} from "../../utils/store/actions/funds.actions";
import ModalCreateFund from "../../components/Modal/Modal.CreateFund";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      marginTop: "2%",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    paperButton: {
      textTransform: "none",
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
      textTransform: "none",
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    TableRowFund: {
      "&:hover": {
        cursor: "pointer",
        background: "#F5F6FF",
      },
    },
  });

class Funds extends Component<any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  handleRefresh = () => {};

  componentDidMount() {
    this.props.getAllFunds("false");
  }

  handleEdit = (id: any) => {
    window.location.href = `/admin/funds/details?id=${id}`;
  };
  render() {
    const { classes, Funds, t } = this.props;
    const { funds_list } = Funds;
    return (
      <div>
        <ModalCreateFund />
        {/* CONTENT */}
        <Paper className={classes.paper}>
          <Row
            style={{
              backgroundColor: "transparent",
              display: "block",
              marginRight: "0px",
              marginLeft: "0px",
            }}
          >
            <Button
              variant="contained"
              style={{
                marginLeft: "10px",
                color: "white",
                backgroundColor: "#ae0064",
              }}
              className={classes.addUser}
              onClick={() =>
                this.props.show("create_fund", {
                  name: "create_fund",
                  history,
                })
              }
            >
              {t("CREATE_PRODUCT")}
            </Button>
            <div className={classes.contentWrapper}>
              <TableContainer component={Paper} style={{ maxHeight: "100vh" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          fontWeight: "bold",
                          backgroundColor: "#F0F3F7",
                        }}
                      >
                        {t("NAME")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {funds_list &&
                      funds_list.map((fund: any) => (
                        <>
                          <TableRow
                            key={fund.id}
                            onClick={(e) => {
                              e.preventDefault(),
                                e.stopPropagation(),
                                this.handleEdit(fund?.person?.id);
                            }}
                            className={classes.TableRowFund}
                          >
                            <TableCell>{fund.name}</TableCell>
                          </TableRow>
                        </>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Row>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getClients,
  getAllFunds,
  show,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Funds)));
